import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesTemplatesCategoryApiService extends EntityApiService {

    search = (params) => ApiClientService.post(this.getPath('/search'), {...params});

    getChildren = ({parentId, ...params}) => ApiClientService.post(this.getPath(`/${parentId}/children`), {...params});

}

export default new NomenclaturesTemplatesCategoryApiService('/ms-core/api/categories');
